import axios from '@/services/servicio-base';

const servicioCarrito = {};

servicioCarrito.modificarCantidad = function(codArticulo, cantidad, rutaOrigen, uuidAcceso) {
   return axios.post('/carrito/modificar-cantidad', {codArticulo, cantidad, rutaOrigen, uuidAcceso})
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

servicioCarrito.consultar = function() {
   return axios.post('/carrito/consultar')
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

servicioCarrito.consultarCedis = function() {
   return axios.post('/carrito/carritoPorCedis')
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

servicioCarrito.consultarCantidadEnCarrito = function()
{   
   return axios.post('/carrito/cantidadEnCarrito')
   .then(r=>{
      return r.data;
   })
   .catch(e=>{
      return e;
   })
},
servicioCarrito.surtir = function(surtirEnVariosCedis, facturarPublicoGeneral){   
   return axios.post('/carrito/surtir',{surtirEnVariosCedis:surtirEnVariosCedis, facturarPublicoGeneral:facturarPublicoGeneral})
   .then(r=>{
      return r.data;
   })
   .catch(e=>{
      return e;
   })
}

servicioCarrito.vaciar = function(){   
   return axios.post('/carrito/vaciar')
   .then(r=>{
      return r;
   })
   .catch(e=>{
      return e;
   })
}

servicioCarrito.migrarCarrito = function(p){   
   return axios.post('/carrito/migrar',p)
   .then(r=>{
      return r;
   })
   .catch(e=>{
      return e;
   })
}

servicioCarrito.migrarArticulosCarritoViejaNueva = function(p){   
   return axios.post('/carrito/migrar-articulos-carrito-vieja-nueva',p)
   .then(r=>{
      return r.data;
   })
   .catch(e=>{
      return e;
   })
}
servicioCarrito.consultarArticulosEXCEL = function(p){   
   return axios.post('/carrito/consultar-articulos-excel',p)
   .then(r=>{
      return r.data;
   })
   .catch(e=>{
      return e;
   })
}

servicioCarrito.surtirDesdeExcel = function(surtirEnVariosCedis, facturarPublicoGeneral, rutaCargado, p){ 
   return axios.post('/carrito/surtir-desde-excel/' + surtirEnVariosCedis + '/' + facturarPublicoGeneral + '/' + rutaCargado, p)
   .then(r=>{
      return r.data;
   })
   .catch(e=>{
      return e;
   })
}

servicioCarrito.FacturarPublicoGeneral = function(){      
   return axios.post('/carrito/facturar-publico-general/')
   .then(r=>{
      return r.data;
   })
   .catch(e=>{
      return e;
   })
}

export default servicioCarrito;